import { configureRequest } from '../../../../networkRequests/apiClient/apiClient.functions'
import urls from '../../../../networkRequests/apiClient/endpoints'
import { UserRole } from '../../../../shared/functions/UserRole/userRoleManagement.types'
import {
  CreateFulfillmentOrderPaymentIntentErrorResponse,
  CreateFulfillmentOrderPaymentIntentRequest,
  CreateFulfillmentOrderPaymentIntentSuccessResponse
} from './createFulfillmentOrderPaymentIntent.types'

export const createFulfillmentOrderPaymentIntentApi = async (
  request: CreateFulfillmentOrderPaymentIntentRequest
): Promise<CreateFulfillmentOrderPaymentIntentSuccessResponse> => {
  const response = await configureRequest({
    url: urls.payments.createFulfillmentOrderPaymentIntent,
    method: 'POST',
    data: request,
    headers: {
      'X-User-Role': UserRole.sender
    }
  })

  if (response.status >= 200 && response.status < 300) {
    return response as CreateFulfillmentOrderPaymentIntentSuccessResponse
  } else {
    throw response as CreateFulfillmentOrderPaymentIntentErrorResponse
  }
}

export default createFulfillmentOrderPaymentIntentApi
